// Review SCAN vague 1, points 11 et 18 : les noms de compétences s'écrivent
// partout exactement comme dans le référentiel — seule la première lettre du
// premier mot est en majuscule, jamais de transformation automatique de casse.
// Source : référentiel Rising Up (18 compétences).

const REFERENTIEL = [
  { nom : "Régulation émotionnelle",        cles : ["controle"] },
  { nom : "Empathie",                       cles : ["empathie"] },
  { nom : "Influence assertive",            cles : ["influence"] },
  { nom : "Positivité",                     cles : ["positif"] },
  { nom : "Prise d’initiative",             cles : ["initiative"] },
  { nom : "Flexibilité mentale",            cles : ["flexible"] },
  { nom : "Raisonnement dans l’incertitude", cles : ["tolerance"] },
  { nom : "Raisonnement divergent",         cles : ["divergent"] },
  { nom : "Raisonnement logique",           cles : ["logique"] },
  { nom : "Curiosité",                      cles : ["curieux"] },
  { nom : "Raisonnement synthétique",       cles : ["synthese"] },
  { nom : "Prise de parole",                cles : ["parole", "prise de parole en public"] },
  { nom : "Persévérance",                   cles : ["persevere"] },
  { nom : "Planification",                  cles : ["planifie"] },
  { nom : "Monitoring",                     cles : ["monitoring"] },
  { nom : "Efficacité",                     cles : ["efficace"] },
  { nom : "Réactivité",                     cles : ["reactif"] },
  { nom : "Rigueur",                        cles : ["rigueur"] },
]

// « Flexibilité Mentale » (base), « flexible », « Prise de parole en public »…
// → forme normalisée sans accents ni casse ni apostrophes pour comparer.
const normaliser = (valeur) => {
  return String(valeur || "")
    .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    .replace(/[’']/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
    .toLowerCase()
}

// Rend le nom du référentiel pour une clé ou un libellé venu de la base.
// Si la compétence est inconnue, rend le libellé d'origine tel quel
// (sans transformation de casse) plutôt que d'inventer.
export const nomCanonique = (cleOuLibelle) => {
  const cherche = normaliser(cleOuLibelle)
  if (!cherche) { return cleOuLibelle }
  const trouve = REFERENTIEL.find((skill) => {
    if (normaliser(skill.nom) === cherche) { return true }
    return skill.cles.some((cle) => normaliser(cle) === cherche)
  })
  return trouve ? trouve.nom : cleOuLibelle
}

export default REFERENTIEL
